import { useWindows } from "@/os/window/context";
import { getDef } from "../window/registry";
import { useAchievements, FOLDER_IDS } from "@/os/state/achievements";
import { play } from "@/lib/sound";
import { withBreaks } from "@/components/decor";

export function DesktopIcon({ id }: { id: string }) {
    const { open } = useWindows();
    const { trackFolder } = useAchievements();
    const def = getDef(id);
    if (!def) return null;
    const Icon = def.icon;
    return (
        <button
            data-testid={`desktop-icon-${id}`}
            className="os-icon"
            aria-label={`Open ${def.label ?? def.title}`}
            onClick={() => {
                play("click");
                if (FOLDER_IDS.includes(id)) trackFolder(id);
                open(id);
            }}
        >
            <span className="os-icon-tile" style={{ background: def.tileBg, color: def.color }}>
                <Icon size={26} strokeWidth={2.1} />
            </span>
            <span className="os-icon-label">{withBreaks(def.label ?? def.title)}</span>
        </button>
    );
}
